import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'

import { useLocation } from '@common/location-layer/composables/useLocation'

/**
 * Switcher sidebar branding context for CPRootContainer.
 */
export function useCPSwitcherSidebar(_currentGroupSlug: ComputedRef<string | null>, _selectedProductId: ComputedRef<string>) {
  const { store: locationStore } = useLocation()
  const { t } = useI18n()

  const portalIcon = computed(() => locationStore.branding?.portalImage || locationStore.branding?.logo || null)
  const portalName = computed(() => locationStore.branding?.portalBannerText || t('auth.branding.defaultPortalName'))

  /** Subtitle under portal name in sidebar (location branding). */
  const portalSubtitle = computed(() => {
    const d = locationStore.branding?.portalDescription
    return d && String(d).trim() ? String(d).trim() : ''
  })

  return {
    portalIcon,
    portalName,
    portalSubtitle,
  }
}
